module.exports = __webpack_public_path__ + "img/MEASURE.c154adf0.svg";